import { render, staticRenderFns } from "./VAMap.vue?vue&type=template&id=263ad072&scoped=true&lang=pug"
import script from "./VAMap.vue?vue&type=script&lang=js"
export * from "./VAMap.vue?vue&type=script&lang=js"
import style0 from "./VAMap.vue?vue&type=style&index=0&id=263ad072&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ad072",
  null
  
)

export default component.exports